<template>
  <FeatureDetailPage feature-key="contracts" />
</template>
